import { Injectable, NgZone, OnInit } from '@angular/core';
import { ActivityEvent, ActivityMonitorService } from '@backbase/identity-auth';
import { OAuthEvent, OAuthService } from 'angular-oauth2-oidc';

/**
 * CustomSessionTimeoutService used to call logout and session services for session management.
 */
@Injectable({
  providedIn: 'root',
})
export class CustomSessionTimeoutService implements OnInit {
  /**
   * CustomSessionTimeoutService constructor
   * @param activityMonitorService Auth service used to monitor user activity.
   * @param ngZone Service for executing work inside or outside of the Angular zone.
   * @param oAuthService angular-oauth2-oidc service.
   */
  constructor(
    private activityMonitorService: ActivityMonitorService,
    private readonly ngZone: NgZone,
    private oAuthService: OAuthService,
  ) {}

  ngOnInit(): void {
    this.oAuthService.events.subscribe((authEvent: OAuthEvent) => {
      console.log('authEvent authEvent', authEvent);
    });
  }

  /**
   * Calls the oAuth logout service to log the user out and revoke a current token.
   * @returns a promise from the logout service.
   */
  logout(): Promise<void> {
    return this.oAuthService.revokeTokenAndLogout();
  }


  /**
   * Calls the oAuth service to initiate a login flow.
   */
  goToLoginPage() {
    console.log('goToLoginPage goToLoginPage goToLoginPage goToLoginPage goToLoginPage')
    this.oAuthService.initLoginFlow();
  }

  refresh() {
    console.log("refresh -- 11")
    this.oAuthService.refreshToken();
  }
}
